import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints, ServerResponseKeys } from '../../../api/Constants';
export var getActiveConsumables = {
  query: function query() {
    return {
      url: Endpoints.GET_ACTIVE_CONSUMABLES,
      body: {
        cache: {
          ignoreCache: true
        }
      }
    };
  },
  providesTags: ['Shop'],
  transformResponse: function () {
    var _transformResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", response[ServerResponseKeys.CALL_RESPONSE]);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function transformResponse(_x) {
      return _transformResponse.apply(this, arguments);
    }

    return transformResponse;
  }()
};